import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetBlocksQuery } from '../impl/blfApi/endpoints/blocks';

export const useBlocksByRanch = (
  ranchId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!ranchId || queryOptions?.skip) {
      return skipToken;
    }

    return { ranch__id__in: [ranchId ?? ''] };
  }, [ranchId, queryOptions?.skip]);

  const {
    currentData: blocks,
    isLoading,
    isFetching,
  } = useGetBlocksQuery(queryParams, queryOptions);

  return {
    blocks,
    isBlocksLoading: isLoading || isFetching,
  };
};
